var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maquetaDashboard"},[_c('Sidebar'),_c('Nav'),_c('div',{staticClass:"mainSection"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }